import {
  ApplicationRef,
  booleanAttribute,
  Component,
  ComponentRef,
  input,
  OnDestroy,
  OnInit,
  output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AtlasDataService } from '../../../core/src';
import { ModalService } from '../core-components/modal/modal.service';
import { SnackbarComponent } from '../core-components/snackbar/snackbar.component';
import { SettingsComponent } from '../notifications/settings/settings.component';
import { AtlasThemingService } from '../theming.service';
import { AtlasTopBarComponent } from '../top-bar/top-bar.component';
import { CustomUserDropdownItem } from '../user-dropdown/user-dropdown.interface';

const MODAL_CONTAINER_ID = 'atlas-navbar-modal-container';

@Component({
  selector: 'atlas-navbar',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss', '../common.scss'],
  standalone: false,
})
export class NavComponent implements OnInit, OnDestroy {
  dropdownItems = input<CustomUserDropdownItem[]>([]);
  hideCenters = input(false, { transform: booleanAttribute });
  hideNotifications = input(false, { transform: booleanAttribute });
  hideLanguageSelector = input(false, { transform: booleanAttribute });
  disableUserDropdown = input(false, { transform: booleanAttribute });
  hideBottomBorder = input(false, { transform: booleanAttribute });
  enableDarkModeToggle = input(false, { transform: booleanAttribute });
  darkModeToggleContext = input<string>('atlas');
  event = output<string>();

  private topbar: ComponentRef<AtlasTopBarComponent>;
  private snackbar: ComponentRef<SnackbarComponent>;

  constructor(
    public apiService: AtlasDataService,
    private appRef: ApplicationRef,
    private themingService: AtlasThemingService,
    private modalService: ModalService,
  ) {
    // Set up theming
    apiService.theming$.pipe(takeUntilDestroyed()).subscribe((theming) => {
      this.themingService.theming = theming;
    });
  }

  ngOnInit(): void {
    document.querySelector('body').style.setProperty('padding-top', 'calc(40px + env(safe-area-inset-top))');

    if (window.location.search.indexOf(SettingsComponent.SETTINGS_DIALOG_PARAM_ID) >= 0) {
      this.modalService.openList(SettingsComponent);
    }
  }

  ngOnDestroy(): void {
    document.querySelector('body').style.setProperty('padding-top', '0');
    if (this.topbar) {
      this.topbar.destroy();
      this.appRef.detachView(this.topbar.hostView);
    }

    if (this.snackbar) {
      this.snackbar.destroy();
      this.appRef.detachView(this.snackbar.hostView);
    }

    const modalContainer = document.getElementById(MODAL_CONTAINER_ID);
    if (modalContainer) {
      modalContainer.remove();
    }
  }

  propagateEvent(eventId: string): void {
    this.event.emit(eventId);
  }
}
